import React from 'react';
import { Card, CardContent, Typography, FormControl, InputLabel, Select, MenuItem, Button, Box } from '@mui/material';

interface PlayerFiltersProps {
  filters: {
    position: string;
    team: string;
    minFantasyPoints: number;
    maxFantasyPoints: number;
    availability: string;
  };
  onFilterChange: (filters: any) => void;
  teams: string[];
}

const PlayerFilters: React.FC<PlayerFiltersProps> = ({ filters, onFilterChange, teams }) => {
  const positions = ['All', 'PG', 'SG', 'SF', 'PF', 'C'];

  const handleFilterChange = (key: string, value: string | number) => {
    onFilterChange({
      ...filters,
      [key]: value
    });
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
          Filters
        </Typography>
        
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <FormControl fullWidth>
            <InputLabel>Availability</InputLabel>
            <Select
              value={filters.availability}
              label="Availability"
              onChange={(e) => handleFilterChange('availability', e.target.value)}
            >
              <MenuItem value="Free Agent">Free Agent</MenuItem>
              <MenuItem value="Rostered">Rostered</MenuItem>
              <MenuItem value="All">All</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel>Position</InputLabel>
            <Select
              value={filters.position}
              label="Position"
              onChange={(e) => handleFilterChange('position', e.target.value)}
            >
              {positions.map(position => (
                <MenuItem key={position} value={position}>{position}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel>Team</InputLabel>
            <Select
              value={filters.team}
              label="Team"
              onChange={(e) => handleFilterChange('team', e.target.value)}
            >
              <MenuItem value="All">All Teams</MenuItem>
              {teams.map(team => (
                <MenuItem key={team} value={team}>{team}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button
            variant="outlined"
            onClick={() => onFilterChange({
              position: 'All',
              team: 'All',
              minFantasyPoints: 0,
              maxFantasyPoints: 100,
              availability: 'Free Agent'
            })}
            sx={{ mt: 1 }}
          >
            Clear Filters
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default PlayerFilters;
